import ForbiddenPage from './ForbiddenPage';

export default ForbiddenPage;
